export default "__VITE_ASSET__DawU5je___"